module.exports = __webpack_public_path__ + "static/img/002.9b69576.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/guide/usdt2/002.png
// module id = e5wT
// module chunks = 1